import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { openDialog, useAppDispatch } from '@fly/store';
import { Separator } from '@radix-ui/themes';

import { ArtifactDistributionDialogContent } from '../components/ArtifactVersionsPage/components/DistributionForm/ArtifactDistributionDialogContent';
import { type OpenArtifactDistributionDialogParams } from '../components/ArtifactVersionsPage/components/DistributionForm/distributionFormKeys';

export type { OpenArtifactDistributionDialogParams } from '../components/ArtifactVersionsPage/components/DistributionForm/distributionFormKeys';

export function useArtifactDistributionDialog() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const openArtifactDistributionDialog = useCallback(
    (params: OpenArtifactDistributionDialogParams) => {
      dispatch(
        openDialog({
          title: t('app.dashboard.artifacts.distribution_form.title', {
            defaultValue: 'Manage Distribution',
          }),
          description: t('app.dashboard.artifacts.distribution_form.subtitle', {
            defaultValue: 'Distribute your artifact to a public audience',
          }),
          content: (
            <>
              <Separator
                orientation='horizontal'
                className='mb-3 mt-3 w-full bg-[var(--slate-a5)]'
              />
              <ArtifactDistributionDialogContent
                artifactName={params.artifactName}
                versionName={params.versionName}
                packageType={params.packageType}
                reopenDistributionDialog={() => {
                  openArtifactDistributionDialog(params);
                }}
              />
            </>
          ),
          showCloseDialog: true,
        })
      );
    },
    // Recursive reopen captures latest openArtifactDistributionDialog per hook instance.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- stable reopen via self-call with same params
    [dispatch, t]
  );

  return { openArtifactDistributionDialog };
}
